module.exports = __webpack_public_path__ + "e3c9a60dfbeb459431ec7db8b75ddd13.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-compound.png
// module id = 630
// module chunks = 0